module.exports = __webpack_public_path__ + "static/media/cover.8734dd96.jpg";